<template>
    <section>
        <el-col :span="24" class="toolbar">
            <el-form :inline="true" class="demo-form-inline" :model="formInline" align="left" style="text-align: left">
                <el-form-item>
                    <el-input v-model="formInline.DeviceId" placeholder="Device ID" @keyup.enter.native=''></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-edit" style="width: 120px" @click.native.prevent="addWhitelist">添加</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <template>
            <el-table :data="whitelistData" highlight-current-row  style="width: 100%;" stripe>
                <el-table-column prop="DeviceId" label="DeviceId" width="400" sortable></el-table-column>
                <el-table-column prop="CreateTime" label="CreateTime" width="300" sortable></el-table-column>
                <el-table-column prop="Action" label="操作" width="200">
                    <template slot-scope="scope">
                        <!--el-button @click="editWhitelist(scope.row)" v-show="seen()" type="primary" size="mini" style="width: auto" icon="el-icon-edit"></el-button-->
                        <el-button @click="deleteWhitelist(scope.row)" v-show="seen()" type="danger" size="mini" icon="el-icon-delete" style="width: auto"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <!--分页-->
        <el-col :span="24" class="toolbar" style="padding-bottom:10px;">
            <el-pagination :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="totaltotal"
                           v-on:current-change="pageIndexChange" v-on:size-change="sizeChange" style="float:none">
            </el-pagination>
        </el-col>
    </section>
</template>
<script>
    import { Config } from "@/config/config"
    import { addLanguage, deleteLanguage } from "@/api/language"
    import { mapState } from 'vuex'
    import Notify from '../../api/notifyMsg'

    export default {
        computed: mapState({
            user: state => state.user
        }),
        data() {
            return {
                whitelistForm: {
                    Id: '',
                    DeviceId: '',
                    CreateTime: ''
                },
                formInline: {
                    DeviceId: '',
                },
                tableJsonData: [],
                listLoading: false,
                editFormTitle: "",
                whitelistData: [],
                editFormVisible: false,
                editLoading: false,
                pageIndex: 1,
                pageSizes: [10, 20, 30, 40, 50],
                pageSize: 10,
                totaltotal: 0,
                listFormRules: {
                    DeviceId: [{
                        required: true, message: '请输入DeviceId',trigger: 'blur'
                    }],
                },
                whitelistApiUrl: '/api/v1/console/whitelist',
            };
        },
        methods: {
            seen() {
                if(this.user.Role !== "admin") {
                    return false;
                } else {
                    return true;
                }
            },
            getData: function () {
                var _this = this;
                var offset = (_this.pageIndex-1) * _this.pageSize;
                _this.whitelistData = [];
                //_this.totaltotal = 0; //这里会导致pagination无法正确的翻页和页面跳转
                fetch(Config.url + _this.whitelistApiUrl + "?offset=" + offset + "&limit=" + _this.pageSize + "&token=" + _this.user.token)
                    .then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json.Error_code === 1000) {
                            var i;
                            for (i = 0; i < json.white_lists.length; i++) {
                                var id = json.white_lists[i].id;
                                var device_id = json.white_lists[i].device_id;
                                var create_time = json.white_lists[i].create_time;
                                var time_str = new Date(parseInt(create_time)).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
                                _this.$set(_this.whitelistData, i, new _this.showWhitelist(id, device_id, time_str));
                            }
                            _this.totaltotal = json.Count;
                        } else {
                            Notify.errMsgNotify(json.Error_code, _this)
                            return
                        }
                    })
                console.log("getData pageIndex:", _this.pageIndex);
            },
            showWhitelist: function(id, device_id,create_time) {
                this.Id = id;
                this.DeviceId = device_id;
                this.CreateTime = create_time;
            },

            deleteWhitelist: function (row) {
                var _this = this;
                _this.$confirm('确认删除吗？', '提示', {}).then(() => {
                    _this.$http.delete(Config.url + _this.whitelistApiUrl, {
                        params: {
                            token: _this.user.token,
                            id: row.Id
                        }
                    })
                        .then((response) => {
                            console.log("Detele ：" + response.data.Error_code)

                            if (response.data.Error_code === 1000) {
                                _this.$notify({
                                    title: '删除成功',
                                    message: '删除成功！',
                                    type: 'success'
                                });
                                _this.getData() //重新获取数据
                            } else {
                                Notify.errMsgNotify(response.data.Error_code, this)
                                return
                            }
                        })
                        .catch(function (response) {
                            Notify.catchMsgNotify(this)
                            console.log(response)
                        })
                });
            },

            addWhitelist: function () {
                var _this = this;
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                var content = _this.formInline.DeviceId;
                console.log(" addWhitelist content:", content);
                if (content.length <= 0) {
                    _this.$notify({
                        title: 'DeviceId错误',
                        message: 'DeviceId不能为空！',
                        type: 'fail'
                    });
                    return
                }

                var i = 0;
                for (; i < _this.whitelistData.length; i ++) {
                    if(_this.whitelistData[i].DeviceId === content) {
                        _this.$notify({
                            title: 'DeviceId错误',
                            message: '该DeviceID已经添加！',
                            type: 'fail'
                        });
                        return
                    }
                }

                _this.$http.post(Config.url + _this.whitelistApiUrl + '?token=' + _this.user.token, {
                    create_time: Date.parse(new Date()),
                    device_id : content
                })
                .then((response) => {
                    console.log(response.data)
                    if (response.data.Error_code === 1000) {
                        _this.$notify({
                            title: '添加成功',
                            message: '添加成功！',
                            type: 'success'
                        });

                        _this.getData() //重新获取数据
                        _this.formInline.DeviceId = '';
                    } else {
                        Notify.errMsgNotify(response.data.Error_code, this)
                        return
                    }
                })
                .catch(function(response) {
                    Notify.catchMsgNotify(this)
                    console.log(response)
                })
            },

            pageIndexChange: function(pageIndex) {
                console.log("pageIndexChange11 :", pageIndex);
                var _this = this
                _this.pageIndex = pageIndex
                _this.getData()
                console.log("pageIndexChange22 :", pageIndex);
            },
            sizeChange: function(pageSize) {
                var _this = this
                _this.pageSize = pageSize
                _this.getData()
            },
        },
        created: function() {

        },
        mounted: function () {
            this.getData();
        }
    }
</script>
<style scoped>
    .toolbar {
        background: #fff;
        /*padding: 10px 10px 0px 10px;*/
    }

    .dialog_input {
        width: 87%;
    }
</style>


// WEBPACK FOOTER //
// src/components/area/WhiteList.vue